import { SERVICE_GROUP_ID } from '@/constants';

export type Link = {
  label: string;
  url: string;
  category: URL_CATEGORIES;
};

export enum URL_CATEGORIES {
  LANDINGPAGE = 'description',
  SUBSCRIBE = 'purchase',
  SUBSCRIPTIONLIST = 'history',
  ADMIN = 'admin',
  TERMS = 'terms',
  OTHERSSO = 'other_sso',
}

export type ServiceGroup = {
  id: number;
  name: string;
  summary: string;
  description: string;
  position: number;
  urls: Link[];
  thumbnailUrl: string;
  imageUrl: string;
};

export const toDisplayName = (serviceGroup: ServiceGroup) => {
  if (serviceGroup.id === SERVICE_GROUP_ID.gls) {
    return 'グロービス・ラーニング・プラットフォーム';
  }
  return serviceGroup.name;
};
